export const uppercase = (s) => {
    if (typeof s !== 'string') return ''
    return s.toUpperCase();
  }